import { render, staticRenderFns } from "./DegreeDetail.vue?vue&type=template&id=3c17d74a&scoped=true&"
import script from "./DegreeDetail.vue?vue&type=script&lang=js&"
export * from "./DegreeDetail.vue?vue&type=script&lang=js&"
import style0 from "./DegreeDetail.vue?vue&type=style&index=0&id=3c17d74a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c17d74a",
  null
  
)

export default component.exports